import { render, staticRenderFns } from "./PermissionsModal.vue?vue&type=template&id=424ee7df&scoped=true&"
import script from "./PermissionsModal.vue?vue&type=script&lang=js&"
export * from "./PermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsModal.vue?vue&type=style&index=0&id=424ee7df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424ee7df",
  null
  
)

export default component.exports